import Table from './table';

export default Table;
export type * from './types';
